import { broadcast } from 'utils/message'

export const requestKillAnnouncementFrames = async () => {
  await broadcast({
    topic: 'kill-announcement-frames',
    message: {}
  })
}
